'use es6';

import PropTypes from 'prop-types';
import TypedRecord from './TypedRecord';
export default TypedRecord({
  type: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired
}, 'IconRecord');